// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"00892265","68":"74ceae3c","79":"9d99dad1","207":"5f663f50","458":"63935089","477":"16855fe4","787":"049e95a4","872":"db926bb1"}[chunkId] + ".chunk.js";
};